import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
// estilos
import "./style/index.css";
// Componentes
import MyInfoCard from "../componets/MyInfoCard";
import Project from "../componets/Project";
import FadeInSection from "../componets/FadeInSection";
import FadeInDownSection from "../componets/FadeInDownSection";
import AboutMeCard from "../componets/AboutMeCard";

// logos de redes
import fb_logo from "../imgs/fb.png";
import ig_logo from "../imgs/ig.png";
import git_logo from "../imgs/git.png";
// logos de skills
import react_logo from "../imgs/logo.svg";
import laravel_logo from "../imgs/Laravel.png";
import express_logo from "../imgs/Express.png";
import sql_logo from "../imgs/sql.png";
import js_logo from "../imgs/js.png";
import html_logo from "../imgs/html.png";
import css_logo from "../imgs/css.png";
import boostrap_logo from "../imgs/boostrap.png";
import mongo_logo from "../imgs/mongo.png";
import gitNegro_logo from "../imgs/github-negro.svg";
//iconos
import { IoIosMenu  } from 'react-icons/io';
import { FaLinkedinIn  } from 'react-icons/fa';

//email post
import emailjs from 'emailjs-com';

function Index() {
  const [optionAboutMe, setOptionAboutMe] = useState("Personal");
  const [bgSkill, setBgSkill] = useState(react_logo);
  const [txtSkillPlus, setTxtSkillPlus] = useState('Hooks, Redux, Redux-thunk, Redux-saga');
  const [menuOn, setMenuOn] = useState(false);


  const handleChangeBg = (bg, plus) => {
    setBgSkill(bg);
    setTxtSkillPlus(plus);
  };

  const handleMenu = () => {
    menuOn ? setMenuOn(false) : setMenuOn(true)
  };

  //Send email to me
  const frmContact = { userEmail:'', userName:'', emailDetails:'' };
   const [contact,setContact] = useState(frmContact);
   const [showMessage, setShowMessage] = useState(false);

   const handleChange = e => { 
		const {name,value} = e.target;
		setContact({...contact,[name]:value}); 
   };

   const hiddeMessageSucces = () => { 
    setTimeout(() => {
      setShowMessage(false);
    }, 2000); 
   };

   const handleSubmit = e =>{
	    e.preventDefault();
	   
		emailjs.send(`gmail`,`template_eiHCmnmC`, contact, `user_eEAd8t3Y11l7J6Vsa3tTq`)
		.then((response) => {
				   console.log(`SUCCESS!`, response.status, response.text);
				   setContact(frmContact);
           setShowMessage(true);
           hiddeMessageSucces();
		}, (err) => {
				   console.log(`FAILED...`, err);
		});
   }

  return (
    <>
    <div className={`menu_nav ${menuOn ? 'on' : ''}`}>
          <Link to="about_me_section" smooth={true} duration={500}>
            About me
          </Link>
          <Link to="portfolio_section" smooth={true} duration={700}>
            Projects
          </Link>
          <Link to="skills_section" smooth={true} duration={900}>
            Skills
          </Link>
          <Link to="main_section_footer" smooth={true} duration={1000}>
            Contact
          </Link>
    </div>
      <section className="hero">
        <div className="container">
          <div className="blue_hero_container">
            <nav className="nav">
              <i className="icon-menu"onClick={() => handleMenu()}><IoIosMenu  /></i>
              <h1 className="nav-name">Daniel Garcia </h1>
              <Link to="about_me_section" smooth={true} duration={500}>
                About me
              </Link>
              <Link to="portfolio_section" smooth={true} duration={700}>
                Projects
              </Link>
              <Link to="skills_section" smooth={true} duration={900}>
                Skills
              </Link>
              <Link to="main_section_footer" smooth={true} duration={1000}>
                Contact
              </Link>
            </nav>
            <div className="img_me">
              <h1 className="name img-name">Daniel Garcia</h1>
              <h1 className="txt_hero">Hi!, I'm <span>Daniel</span><br/>I love to make <span>art</span> <br/> with <span>JavaScript</span></h1>
            </div>
            <div className="blue decoration_column_img decoration_column">
                <h1 className="txt_column web_column_blue">
                    <FadeInSection>
                  <span>WEB</span>
                    </FadeInSection>
                </h1>
            </div>
          </div>
          <h1 className="txt_column dev_column_white decoration_column">
            <FadeInDownSection>
              <span>DEV</span>
            </FadeInDownSection>
          </h1>
        </div>
      </section>

      <section className="about_me_section">
        <div className="container">
          <div className="blue_column"></div>
          <FadeInSection>
            <AboutMeCard handleOption={setOptionAboutMe} />
            <MyInfoCard handleOption={setOptionAboutMe} option={optionAboutMe} />
          </FadeInSection>
        </div>
      </section>

      <section className="portfolio_section">
        <div className="portfolio_container">
          <div className="container">
            <h4 className="tittle_section tittle_section_portfolio">
              My projects
            </h4>
            <FadeInSection>
              <Project projectName={"Education plataform"} />
            </FadeInSection>
            <FadeInSection>
              <Project projectName={"Usa machinery"} />
            </FadeInSection>
            <FadeInSection>
              <Project projectName={"Fruvi eCommerce"} />
            </FadeInSection>
            <FadeInSection>
              <Project projectName={"Order Pizza"} />
            </FadeInSection>
            <FadeInSection>
              <Project projectName={"EnjoyItBeach"} />
            </FadeInSection>
            <FadeInSection>
              <Project projectName={"4anniversary"} />
            </FadeInSection>
            <FadeInSection>
              <Project projectName={"Simon-says-Game---JS"} />
            </FadeInSection>
          </div>
        </div>
      </section>

      <section className="skills_section">
        <div className="especial_container_skills">
          <img className="skillbg_img" src={bgSkill} alt="" />
        </div>
        <div className="skills_container">
        
          <div className="container">
          <div className="skills_txt_container">
            <h4 className="tittle_section tittle_section_skills">Skills</h4>
            <strong className="txtplus">{txtSkillPlus ? `(${txtSkillPlus})` : ''}</strong>
          </div>
            <div className="part_container">
              <div className="left_part parts">
                <FadeInSection>
                  <div
                    className="skill_one skills_cube"
                    onMouseOver={() => handleChangeBg(react_logo, 'Hooks, Redux, Redux-thunk')}
                  >
                    <div className="logo_container">
                      <img src={react_logo} alt="react-logo" />
                      <h3>React Js</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_two skills_cube"
                    onMouseOver={() => handleChangeBg(laravel_logo)}
                  >
                    <div className="logo_container">
                      <img src={laravel_logo} alt="react-logo" />
                      <h3>Laravel</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_three skills_cube"
                    onMouseOver={() => handleChangeBg(express_logo, 'NodeJs & Express')}
                  >
                    <div className="logo_container">
                      <img src={express_logo} alt="react-logo" />
                      <h3>Express Js</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_four skills_cube"
                    onMouseOver={() => handleChangeBg(sql_logo)}
                  >
                    <div className="logo_container">
                      <img src={sql_logo} alt="react-logo" />
                      <h3>MySQL</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_four skills_cube"
                    onMouseOver={() => handleChangeBg(mongo_logo)}
                  >
                    <div className="logo_container">
                      <img src={mongo_logo} alt="react-logo" />
                      <h3>Mongo DB</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_five skills_cube"
                    onMouseOver={() => handleChangeBg(js_logo, 'Es6+')}
                  >
                    <div className="logo_container">
                      <img src={js_logo} alt="react-logo" />
                      <h3>JavaScript</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_six skills_cube"
                    onMouseOver={() => handleChangeBg(html_logo)}
                  >
                    <div className="logo_container">
                      <img src={html_logo} alt="react-logo" />
                      <h3>HTML5</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_seven skills_cube"
                    onMouseOver={() => handleChangeBg(css_logo, 'CSS Flexbox Layout, CSS Grid Layout')}
                  >
                    <div className="logo_container">
                      <img src={css_logo} alt="react-logo" />
                      <h3>CSS3</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_seven skills_cube"
                    onMouseOver={() => handleChangeBg(gitNegro_logo)}
                  >
                    <div className="logo_container">
                      <img src={gitNegro_logo} alt="react-logo" />
                      <h3>Git y Github</h3>
                    </div>
                    <span></span>
                  </div>
                  <div
                    className="skill_seven skills_cube"
                    onMouseOver={() => handleChangeBg(boostrap_logo)}
                  >
                    <div className="logo_container">
                      <img src={boostrap_logo} alt="react-logo" />
                      <h3>Boostrap</h3>
                    </div>
                    <span></span>
                  </div>
                </FadeInSection>
              </div>
              <div className="right_part parts">
                <FadeInSection>
                  <div className="languages_container">
                    <h3 className="tittle_languages">languages</h3>
                    <div className="languages_circules_container">
                      <div className="circule_language">
                        <h3 className="lvl_language">B2</h3>
                        <h2 className="language">English</h2>
                      </div>
                      <div className="circule_language">
                        <h3 className="lvl_language">Native</h3>
                        <h2 className="language">Spanish</h2>
                      </div>
                    </div>
                  </div>
                </FadeInSection>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer>
        <section className="main_section_footer">
          <div className="container">
            <form onSubmit={handleSubmit} className="form-email">
              <div className={`alert ${showMessage ? '' : 'hidden'}`} role="alert">Email Send Success!!</div>
              <h3>let's create something together</h3>
              <input required type="email" value={contact.userEmail} name="userEmail" onChange={handleChange} className="form-control" placeholder="Your email" />
              <input required type="text" value={contact.userName} name="userName" onChange={handleChange} className="form-control" placeholder="Your name" />
              <textarea required name="emailDetails" onChange={handleChange} className="form-control" placeholder="What can I do for you?" value={contact.emailDetails}></textarea>
              <button type="submit">Send</button>
            </form>
            <div className="social">
              <a href="https://web.facebook.com/daniel98garcia">
                <img className="contact fb" src={fb_logo} alt="fb-Link" />
              </a>
              {/* <a href="https://www.instagram.com/daniel98garcia/">
                <img className="contact ig" src={ig_logo} alt="" />
              </a> */}
              <a href="https://github.com/garcia98daniel">
                <img className="contact git" src={git_logo} alt="" />
              </a>
              <a href="https://www.linkedin.com/in/daniel-antonio-garcia-arias-5661141b3/">
                <i className="contact git" ><FaLinkedinIn/></i>
              </a>
            </div>
          </div>
        </section>
        <section className="second_section_footer">
          <div className="container">
            <div className="txt_footer">
              <p>Designed and created by Daniel Garcia Arias 2020.<br></br> All rights reserved ©</p>
            </div>
            <div className="txt_my_words">
              <h3>Innovate</h3>
              <h3>Create</h3>
              <h3>Share ❤️</h3>
            </div>
          </div>
        </section>
      </footer>
    </>
  );
}

export default Index;
